import SubLabel from "components/Atoms/Sublabel";
import PickerList from "components/Picker/PickerList";
import React from "react";
import { PickerListProps } from "../props";
import { PhosphorWarning } from "components/Atoms/PhosphorIcon";

interface ContactListProps extends PickerListProps<server.dto.ContactSmallV2> {
  initialKeyword?: string;
  excludeKeys?: number[];
}

const ContactList = (props: ContactListProps) => {
  const [instruction, setInstruction] = React.useState<server.dto.ListContactInstruction>({
    page: 1,
    perPage: 20,
    keyword: props.initialKeyword || "",
    excludeKeys: props.excludeKeys || []
  });

  return <PickerList
    instruction={instruction}
    onInstructionChange={setInstruction}
    queryKey="contactlist"
    api={window.CoreApi.Contact.PaginatedSmall}
    onItemSelected={props.onItemSelected}
    getError={() => undefined}
    excludeKeys={props.excludeKeys}
    getId={contact => contact.contactId}
    renderListItem={contact => <div className="flex">
      <div className="grow1">
        <div>{contact.name.fullName}</div>
        <SubLabel>{contact.position}</SubLabel>
      </div>

      {!contact.isValidated && (
        <div>
          <PhosphorWarning iconSize="large" />
        </div>)}
    </div>}
  />
};

export default ContactList;